<template lang="html">

  <form class="container row-between" id="formContacto" @submit.prevent="validateBeforeSubmit">

    <div class="contenedor-input">
      <input type="text" class="input-text" v-validate="'required'" name="nombre" placeholder="Nombre*" />
      <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('nombre') }}</span>
    </div>

    <div class="contenedor-input">
      <input type="text" class="input-text" v-validate="'required'" name="apellidos" placeholder="Apellidos*" />
      <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('apellidos') }}</span>
    </div>

    <div class="contenedor-input -middle">
      <input type="text" class="input-text" v-validate="'required|email'" name="email" placeholder="Email*" />
      <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('email') }}</span>
    </div>

    <div class="contenedor-input -middle">
      <input type="text" class="input-text" v-validate="'length:9|required'" name="telefono" placeholder="Teléfono" />
      <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('telefono') }}</span>
    </div>

    <div class="contenedor-input">
      <select name="entidad" v-validate="'required'" v-model="form.entidad" >
        <option value="">Entidad</option>
        <option v-for="data in entidades" :value="data[0]">{{data[1]}}</option>
      </select>
      <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('entidad') }}</span>
    </div>

    <div class="contenedor-input">
      <textarea placeholder="Mensaje*" name="mensaje" v-validate="'required'"></textarea>
      <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('mensaje') }}</span>
    </div>


    <div class="contenedor-input -check">
      <input type="checkbox" class="input-check" name="politica" id="politica" v-validate="'required'" />
      <label for="politica">He leído y acepto la <a target="_blank" href="https://fundacion.usal.es/es/politica-de-privacidad">política de privacidad.</a>*</label>
      <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('politica') }}</span>
    </div>

    <button v-if="!enviado" class="btn">Enviar</button>

    <h4 v-if="enviado">Enviado</h4>
    
  </form>   

</template> 

<script lang="js">   


  import Vue from 'vue';
  import VeeValidate from 'vee-validate';

  Vue.use(VeeValidate);

  import { mapGetters, mapActions } from 'vuex'

  import axios from 'axios';


  export default {
    name: 'formulario',
    data() {
      return {
        clicked: false,
        enviado : false,
        form: {
          idTipoContacto: '',
          entidad : ''
        },
        entidades: [],
        asuntos: {
          "1": [
            "Registro y acceso",
            "Información/requisitos Programas de Prácticas",
            "Información/requisitos Bolsa de Empleo",
            "Preselección/selección ofertas de Prácticas",
            "Preselección/selección ofertas de Empleo",
            "Dudas durante la práctica (trámites, documentación…)",
            "General / Otros",
          ],
          "2": [
            "Registro y acceso",
            "Información/requisitos Programas de Prácticas",
            "Información/requisitos Bolsa de Empleo",
            "Registro/preselección/selección ofertas de Prácticas",
            "Registro/preselección/selección ofertas de Empleo",
            "Dudas durante la práctica (trámites, documentación…)",
            "General / Otros",
          ],
          "3": [
            "Dudas durante la práctica (trámites, documentación…)",
            "General / Otros"
          ],
          "4": [
            "Registro y acceso",
            "Nombramiento Tutores Académicos",
            "General / Otros",
          ],
          "5": [
            "Registro y acceso",
            "Aceptación/Rechazo tutoría de práctica",
            "Dudas durante la práctica (visitas, documentación…)",
            "General / Otros",
          ]
        }
      }
    },
    mounted(){
      this.getData();
    },
    methods: {
      ...mapActions(['sendContacto']),
      validateBeforeSubmit: function () {
        this.clicked = true;
        this.$validator.validateAll().then(canSend => {
          if (canSend) {
            this.sendContacto($("#formContacto").serialize()).then(result => {
              if(result){
                this.enviado = true;
                $("#formContacto")[0].reset()
              }
            });
          }
        });
      },
      getData(){
        axios.get(`/api/dominios/tiposSolicitudContacto`).then(response => {
					this.entidades = Object.entries(response.data.datos).sort(function (p1, p2) {
						return (p1[1] < p2[1]) ? -1 : 1;
					});
				}).catch(function (error) { });
      },
      setEntidad(){
        this.form.entidad = this.entidades.filter(e => e[0] == this.form.idTipoContacto)[0][1]
      }
    },

  }
</script>


// WEBPACK FOOTER //
// src/components/view-parts/contacto/formulario.vue